module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalState) ? _c('div', {
    staticClass: "diag-full animated fadeInUp"
  }, [_c('div', {
    staticClass: "div-close text-xs-right"
  }, [_c('button', {
    staticClass: "hvr-grow",
    attrs: {
      "aria-label": "Cerrar contenido"
    },
    on: {
      "click": function($event) {
        _vm.closeDiag()
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-red"
  }, [_vm._v("fa-times ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "diag-cont"
  }, [_c('div', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._t("content")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760c2826","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Diagfull.vue
// module id = 1039
// module chunks = 1